import Breadcrumbs, { BreadcrumbsItem } from '@atlaskit/breadcrumbs';
import PageHeader from '@atlaskit/page-header';
import { Box, Stack, Text, xcss } from '@atlaskit/primitives';
import type { ReactNode } from 'react';

type RDAPageHeaderProps = {
	additionalBreadcrumbItems: ReactNode[];
	headingText: string;
	descriptionText?: string;
	description?: ReactNode;
};

export const RovoDevAgentsPageHeader = ({
	additionalBreadcrumbItems,
	headingText,
	descriptionText,
	description,
}: RDAPageHeaderProps) => {
	const breadCrumbs = (
		<Breadcrumbs>
			<BreadcrumbsItem href="/dev-agents/" text="Rovo Dev Agents" key="rovo-dev-agents" />
			{additionalBreadcrumbItems}
		</Breadcrumbs>
	);

	return (
		<Stack>
			<PageHeader breadcrumbs={breadCrumbs} testId="page-header-heading">
				<Box xcss={headingStyles}>{headingText}</Box>
			</PageHeader>
			{descriptionText && <Text>{descriptionText}</Text>}
			{description}
		</Stack>
	);
};

const headingStyles = xcss({ paddingTop: 'space.100', paddingBottom: 'space.100' });
